export const COLLECTIVE_ORDER_MODAL = 'collective-order-modal'
